import { useReportAccessStore } from '../stores/reportAccessStore'
import { useReportLevelStore } from '../stores/reportLevelStore'
import { useReportScheduleStore } from '../stores/reportScheduleStore'

import { registerBootstrapHydrator, type MappedBootstrapResult } from '@/features/account'

function hydrateReports(result: MappedBootstrapResult): void {
  const store = useReportAccessStore()
  store.selectAccount(result.meta.account_id)
  if (result.reports !== null) store.setReports(result.reports)
}

function hydrateSchedules(result: MappedBootstrapResult): void {
  const store = useReportScheduleStore()
  store.selectAccount(result.meta.account_id)
  // `null` means failed/cold: retain warm state for the same account. `[]` is explicit empty.
  if (result.navSchedules !== null) store.setSchedules(result.navSchedules)
}

function hydrateDimensions(result: MappedBootstrapResult): void {
  if (result.workspaceLevels !== null)
    useReportLevelStore().setWorkspaceLevels(result.workspaceLevels)
  if (result.dropdownables !== null) useReportScheduleStore().setDropdownables(result.dropdownables)
}

let unregister: (() => void) | null = null

/** Register module 08 as the owner of report access, schedules and schedule dropdownables. */
export function registerReportBootstrapHydrators(): () => void {
  unregister?.()
  const accessStore = useReportAccessStore()
  const scheduleStore = useReportScheduleStore()
  const levelStore = useReportLevelStore()
  const disposers = [
    registerBootstrapHydrator('reports', {
      hydrate: hydrateReports,
      reset: () => accessStore.reset(),
    }),
    registerBootstrapHydrator('schedules', {
      hydrate: hydrateSchedules,
      reset: () => scheduleStore.resetSchedules(),
    }),
    // Dropdownables ride the workspace-scoped `dimensions` section in the landed wire contract.
    registerBootstrapHydrator('dimensions', {
      hydrate: hydrateDimensions,
      reset: () => {
        scheduleStore.resetDropdownables()
        levelStore.resetState()
      },
    }),
  ]
  unregister = () => {
    for (const dispose of disposers) dispose()
    unregister = null
  }
  return unregister
}
